import { MerlinActionTypes } from './merlin.types';

export const initialState = {
  maiaAgent: 'general',
  loading: false,
  token: null,
  merlinUrl: null,
  isIframeOpen: false,
  chatId: null,
  chatCookieName: '',
  migrationData: {
    hostingId: null,
    domain: '',
    type: '',
  },
  chatHistory: [],
  audioTranscription: '',
  loadingTranscription: false,
  renderInHouseChat: false,
  minimizedChat: false,
  visibleAiChat: false,
  currentChat: {
    route: null,
    fullScreen: false,
    threadid: null,
  },
  sideContent: {
    isOpen: false,
    url: '',
  },
  externalMessage: '',
  externalAudioBlob: null,
  ratedMessages: [],
};

const merlinReducer = (state = initialState, action) => {
  switch (action.type) {
    case MerlinActionTypes.AI_CHAT_RATE_MESSAGE: {
      return {
        ...state,
        ratedMessages: action.payload.ratedMessages,
      };
    }
    case MerlinActionTypes.TOGGLE_FULLSCREEN: {
      return {
        ...state,
        currentChat: {
          ...state.currentChat,
          fullScreen: !state.currentChat.fullScreen,
        },
      };
    }
    case MerlinActionTypes.AICHAT_SET_CHAT_STATE: {
      return {
        ...state,
        currentChat: {
          ...state.currentChat,
          ...action.payload,
        },
      };
    }
    case MerlinActionTypes.POC_VISIBILITY_INHOUSE_CHAT: {
      return {
        ...state,
        visibleAiChat: action.payload,
      };
    }
    case MerlinActionTypes.POC_MINIMIZE_INHOUSE_CHAT: {
      return {
        ...state,
        minimizedChat: action.payload,
      };
    }
    case MerlinActionTypes.MERLIN_GENERATE_TOKEN: {
      return {
        ...state,
        loading: true,
      };
    }
    case MerlinActionTypes.MERLIN_GENERATE_TOKEN_SUCCESS: {
      return {
        ...state,
        loading: false,
        token: action.payload.token,
      };
    }
    case MerlinActionTypes.MERLIN_GENERATE_TOKEN_FAIL: {
      return {
        ...state,
        loading: false,
      };
    }
    case MerlinActionTypes.MERLIN_SET_URL: {
      return {
        ...state,
        loading: false,
        merlinUrl: action.payload.url,
      };
    }
    case MerlinActionTypes.MERLIN_SET_CHAT_DATA: {
      const { chatId, cookieName, isIframeOpen } = action.payload;
      return {
        ...state,
        chatId,
        chatCookieName: cookieName,
        isIframeOpen,
      };
    }
    case MerlinActionTypes.MERLIN_SET_MIGRATION_DATA: {
      const { hostingId, domain, type } = action.payload;
      return {
        ...state,
        migrationData: {
          ...state.migrationData,
          hostingId,
          domain,
          type,
        },
      };
    }
    case MerlinActionTypes.MERLIN_RESET: {
      return {
        ...initialState,
        token: null,
        merlinUrl: null,
        isIframeOpen: false,
        chatId: null,
        migrationData: {
          hostingId: null,
          domain: '',
          type: '',
        },
      };
    }
    case MerlinActionTypes.POC_SET_RESPONSE: {
      const newChatHistory = [...state.chatHistory];
      const isArray = typeof action.payload.response === 'object' && Array.isArray(action.payload.response);

      if (isArray) {
        action.payload.response.forEach((item) => {
          newChatHistory.push(item);
        });
      }

      if (!isArray) {
        newChatHistory.push(action.payload.response);
      }

      return {
        ...state,
        chatHistory: newChatHistory,
      };
    }
    case MerlinActionTypes.POC_RENDER_INHOUSE_CHAT: {
      if (!action.payload) {
        return {
          ...initialState,
          migrationData: { ...state.migrationData },
        };
      }

      return {
        ...state,
        renderInHouseChat: action.payload,
      };
    }

    case MerlinActionTypes.SET_LOADING_TRANSCRIPTION: {
      return {
        ...state,
        loadingTranscription: action.payload,
      };
    }

    case MerlinActionTypes.GET_AUDIO_TRANSCRIPTION: {
      return {
        ...state,
        audioTranscription: action.payload.result,
        loadingTranscription: false,
      };
    }

    case MerlinActionTypes.SET_TRANSCRIPTION_ERROR: {
      return {
        ...state,
        loadingTranscription: false,
      };
    }
    case MerlinActionTypes.SET_MAIA_AGENT: {
      return {
        ...state,
        maiaAgent: action.payload,
      };
    }
    case MerlinActionTypes.SET_SIDE_CONTENT: {
      return {
        ...state,
        sideContent: {
          ...state.sideContent,
          isOpen: action.payload.isOpen,
          url: action.payload.url,
        },
      };
    }
    case MerlinActionTypes.RESET_SIDE_CONTENT: {
      return {
        ...state,
        sideContent: {
          ...state.sideContent,
          isOpen: false,
          url: '',
        },
      };
    }
    case MerlinActionTypes.GENERATE_THREAD_ID: {
      const generatedThreadId = state.currentChat.threadid || `thread_${Date.now().toString()}`;

      return {
        ...state,
        currentChat: {
          ...state.currentChat,
          threadid: generatedThreadId,
        },
      };
    }
    case MerlinActionTypes.SET_EXTERNAL_MESSAGE: {
      return {
        ...state,
        externalMessage: action.payload,
      };
    }
    case MerlinActionTypes.SET_ROUTE: {
      return {
        ...state,
        currentChat: {
          ...state.currentChat,
          route: action.payload,
        },
      };
    }
    case MerlinActionTypes.SET_EXTERNAL_AUDIO_BLOB: {
      return {
        ...state,
        externalAudioBlob: action.payload,
      };
    }
    default:
      return state;
  }
};

export default merlinReducer;
